// export const EXTERNAL_URL = "https://winlocal.logabyss.com";
export const EXTERNAL_URL = "https://api.logabyss.com";
export const LOCAL_API = "http://localhost:3000";

export const API_URL = process.env.REACT_APP_LOCAL ? LOCAL_API : EXTERNAL_URL;
